import { Checkbox, Stack, TextInput } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { MarkdownEditor } from "@/components/controls"
import { surveyInvite } from "@/utils"
import type { IStepInitialValues, IStepProps } from "./types"

export function NotifyStep({ activity, form }: IStepProps) {
  const { t } = useTranslation()

  const defaultInvite = (form.values as any).defaultInvite
  const activityInvite = activity.meta?.invite || t(surveyInvite)

  return (
    <Stack>
      <TextInput label={t("Survey title")} {...form.getInputProps("title")} />

      <MarkdownEditor
        test
        disabled={defaultInvite}
        label={t("Notification message")}
        {...form.getInputProps("note")}
        value={defaultInvite ? activityInvite : form.values.note}
      />
      <Checkbox label={t("Use Survey's defaults")} {...form.getInputProps("defaultInvite", { type: "checkbox" })} />
    </Stack>
  )
}

NotifyStep.label = "Notifications"

NotifyStep.initialValues = ({ activity, session }: IStepInitialValues) => ({
  title: session?.title ?? activity?.title,
  note: session?.note,
  defaultInvite: !session?.note,
})

NotifyStep.transformValues = ({ defaultInvite, ...values }) => {
  return {
    ...values,
    note: defaultInvite ? undefined : values.note,
  }
}
